import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import BillService from '../services/BillService';

const initialState = {
    data: null,
    datas: [],
    pagination: {
        page: 0,
        per_page: 10,
        total: 10,
        totalPages: 10,
    },
    error: null,
    status: '',
    loading: false,
    submitLoading: false,
    summary: {
        total_outstanding_payables: 0,
        selected_date_range_payables: 0,
        outside_date_range_payables: 0,
        filter_total_bill_amount: 0,
        filter_total_balance_due: 0,
    },
};

export const billList = createAsyncThunk(
    'bill/list',
    async (payload) => {
        try {
            const resp = await BillService.List(payload);
            return resp;
        } catch (e) {
            return e.response;
        }
    },
);

export const billAdd = createAsyncThunk('bill/add', async ({ data, navigate }) => {
    try {
        const resp = await BillService.Create(data);
        if (resp?.status === 200) {
            const id = resp.data?.data?.id || resp.data?.id;
            const pathBase = data?.status === 'paid' ? 'paid' : 'unpaid';
            if (id) {
                navigate(`/bills/${pathBase}/${id}`);
            } else {
                navigate('/bills');
            }
        }
        return resp;
    } catch (e) {
        return e.response;
    }
});

export const billEdit = createAsyncThunk('bill/edit', async ({ id, data, navigate }) => {
    try {
        const resp = await BillService.Put(id, data);
        if (resp?.status === 200) {
            const pathBase = data?.status === 'paid' ? 'paid' : 'unpaid';
            navigate(`/bills/${pathBase}/${id}`);
        }
        return resp;
    } catch (e) {
        return e.response;
    }
});

export const getBillDetail = createAsyncThunk('bill/detail', async ({ id }) => {
    try {
        const resp = await BillService.Detail(id);
        return resp;
    } catch (error) {
        return error.response;
    }
});

const billAction = createSlice({
    name: 'bill',
    initialState: initialState,
    reducers: {
        clearBillList: (state) => {
            state.datas = [];
            state.pagination = initialState.pagination;
            state.summary = initialState.summary;
            console.log("here");
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(billList.pending, (state) => {
                state.loading = true;
            })
            .addCase(billList.fulfilled, (state, action) => {
                if (action.payload?.status === 200) {
                    state.datas = [...action.payload?.data?.data?.billList];
                    state.pagination = action.payload?.data?.data?.pagination;
                    state.summary = action.payload?.data?.data?.summary || initialState.summary;
                } else {
                    state.error = action.payload?.data.message;
                    toast.error(state.error);
                }
                state.loading = false;
            })
            .addCase(billList.rejected, (state, action) => {
                state.error = action.payload?.data;
                state.loading = false;
            })
            .addCase(billAdd.pending, (state) => {
                state.submitLoading = true;
            })
            .addCase(billAdd.fulfilled, (state, action) => {
                if (action.payload?.status === 200) {
                    state.status = 'achieve';
                    toast.success(action.payload?.data.message);
                } else {
                    toast.error(action.payload?.data.message);
                }
                state.submitLoading = false;
            })
            .addCase(billAdd.rejected, (state, action) => {
                state.error = action.payload?.data;
                state.submitLoading = false;
            })
            .addCase(billEdit.pending, (state) => {
                state.submitLoading = true;
            })
            .addCase(billEdit.fulfilled, (state, action) => {
                if (action.payload?.status === 200) {
                    toast.success(action.payload?.data.message);
                } else {
                    toast.error(action.payload?.data.message);
                }
                state.submitLoading = false;
            })
            .addCase(billEdit.rejected, (state, action) => {
                state.error = action.payload?.data;
                state.submitLoading = false;
            })
            .addCase(getBillDetail.pending, (state) => {
                state.loading = true;
            })
            .addCase(getBillDetail.fulfilled, (state, action) => {
                if (action.payload?.status === 200) {
                    state.data = action.payload?.data?.data;
                } else {
                    toast.error(action.payload?.data.message);
                }
                state.loading = false;
            })
            .addCase(getBillDetail.rejected, (state, action) => {
                state.error = action.payload?.data;
                state.loading = false;
            });
    },
});

const { reducer, actions } = billAction;
export const { clearBillList } = actions;
export const billSelector = (state) => state.bill;
export default reducer;
